import styled from "styled-components"

export const HeaderRow = styled.div`
  background-color: var(--mainDark);
  padding: 16px;
  display: flex;
  color: white;
`

export const Row = styled.div`
  bacground: transparent;
  padding: 16px;
  display: flex;
  font-color: var(--mainDark);
  border-bottom: 1px solid var(--mainDark);
`
